import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalSettingsKey } from '@shared/types/local-settings';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | Promise<boolean> | Observable<boolean> => {
  const router = inject(Router);

  const user = localStorage.getItem(LocalSettingsKey.USER);
  if (!user) {
    window.location.href = '/home';
    return false;
  } else {
    return true;
  }
};
